/**
 * Created by wangjianwen on 2017/10/16.
 */
export default {
    setExamRegId : ({commit}, param) => commit('setExamRegId',{examRegId: param}),
    setExamRegInfo : ({commit}, param) => commit('setExamRegInfo',{examRegInfo: param}),
    setExamRegInfoItem:({commit}, param) => commit('setExamRegInfoItem',{subExamRegInfo: param}),
    setBatchId : ({commit}, param) => commit('setBatchId',{batchId: param}),
    setPromiseState : ({commit}, param) => commit('setPromiseState',{promiseState: param}),
    setBackOrNextStep: ({commit}, param) => commit('setBackOrNextStep',{backOrNextStep: param}),
}